import * as yup from "yup";

export const createValidationSchema = yup.object().shape({
  code: yup.string().required("Vui lòng nhập mã đơn vị tính"),
  name: yup.string().required("Vui lòng nhập tên đơn vị tính"),
  notes: yup.string().nullable().optional(),
});
